import React, { useState } from "react";
import { Table, Collapse, Button } from "reactstrap";
import PropTypes from "prop-types";
import formatCurrency from "constants/formatCurrency";
import formatDate from "constants/formatDate";

const SureParkReportTable = ({ locations }) => {
    const [expanded, setExpanded] = useState({});
    const [page, setPage] = useState({});
    const itemsPerPage = 5;

    const toggleExpand = (id) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const paginate = (arr, locId) => {
        const currentPage = page[locId] || 1;
        const start = (currentPage - 1) * itemsPerPage;
        return arr.slice(start, start + itemsPerPage);
    };

    const totalPages = (arr) => Math.max(1, Math.ceil(arr.length / itemsPerPage));

    return (
        <div className="overflow-x-auto">
            <Table bordered responsive className="align-middle table-nowrap">
                <thead className="table-light">
                    <tr>
                        <th>Location</th>
                        <th>Transactions</th>
                        <th>Revenue</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {locations.filter(item => item.transactions.length > 0).map((loc) => {
                        const totalRevenue = loc.transactions.reduce(
                            (acc, t) => acc + (t.amount || 0),
                            0
                        );
                        const currentPage = page[loc.id] || 1;
                        const paginatedTxns = paginate(loc.transactions, loc.id);

                        return (
                            <React.Fragment key={loc.id}>
                                <tr>
                                    <td>{loc.name}</td>
                                    <td>{loc.transactions.length}</td>
                                    <td>${formatCurrency(totalRevenue)}</td>
                                    <td>
                                        {loc.transactions.length > 0 && (
                                            <Button
                                                className="button-gradient-bg"
                                                onClick={() => toggleExpand(loc.id)}
                                            >
                                                {expanded[loc.id] ? "Hide Revenues" : "View Revenues"}
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className="p-0 border-0">
                                        <Collapse isOpen={expanded[loc.id]}>
                                            <Table
                                                bordered
                                                size="sm"
                                                responsive
                                                className="mb-0 table-striped"
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Revenue</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginatedTxns.map((t) => (
                                                        <tr key={t.id}>
                                                            <td>{formatDate(t.revenue_date)}</td>
                                                            <td>${formatCurrency(t.amount)}</td>
                                                        </tr>
                                                    ))}
                                                    {loc.transactions.length === 0 && (
                                                        <tr>
                                                            <td colSpan="2" className="text-center py-3">
                                                                No transactions found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                            {loc.transactions.length > itemsPerPage && (
                                                <div className="d-flex justify-content-between align-items-center p-2">
                                                    <Button
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() =>
                                                            setPage((prev) => ({
                                                                ...prev,
                                                                [loc.id]: Math.max(1, currentPage - 1),
                                                            }))
                                                        }
                                                        disabled={currentPage === 1}
                                                    >
                                                        Previous
                                                    </Button>
                                                    <span>
                                                        Page {currentPage} of {totalPages(loc.transactions)}
                                                    </span>
                                                    <Button
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() =>
                                                            setPage((prev) => ({
                                                                ...prev,
                                                                [loc.id]: Math.min(
                                                                    totalPages(loc.transactions),
                                                                    currentPage + 1
                                                                ),
                                                            }))
                                                        }
                                                        disabled={currentPage === totalPages(loc.transactions)}
                                                    >
                                                        Next
                                                    </Button>
                                                </div>
                                            )}
                                        </Collapse>
                                    </td>
                                </tr>
                            </React.Fragment>
                        );
                    })}
                    {locations.length === 0 && (
                        <tr>
                            <td colSpan={3} className="text-center py-3">
                                No locations found
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

SureParkReportTable.propTypes = {
    locations: PropTypes.array.isRequired,
};

export default SureParkReportTable;